// safe namespaced in-browser persistence (currently localStorage only)
const globalScope = window as any;

export default class Persistence {
  static createNamespace(...keys) {
    return new Persistence(keys.join(`:`));
  }

  static createCachedNamespace(...keys) {
    const namespace = keys.join(`:`);

    if (!globalScope.persistenceMemoryCache) {
      globalScope.persistenceMemoryCache = {};
    }

    if (!globalScope.persistenceMemoryCache[namespace]) {
      globalScope.persistenceMemoryCache[namespace] = new Map();
    }

    return new Persistence(namespace, globalScope.persistenceMemoryCache[namespace]);
  }

  public namespace: string;
  public cache: Map<string, Record<string, any>>;

  constructor(namespace, cache = new Map()) {
    this.namespace = namespace;
    this.cache = cache;
  }

  public get(key) {
    try {
      return globalScope.localStorage.getItem(this.keyFor(key));
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  public set(key, val) {
    try {
      globalScope.localStorage.setItem(this.keyFor(key), val);
    } catch (err) {
      console.error(err);
    }
  }

  public getObject(key) {
    try {
      const localKey = this.keyFor(key);
      let value;

      if (this.cache.has(localKey)) {
        value = this.cache.get(localKey);
      } else {
        value = JSON.parse(globalScope.localStorage.getItem(localKey));
      }

      // Load into cache as object
      this.cache.set(localKey, value);

      return value;
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  public setObject(key, val) {
    try {
      const localKey = this.keyFor(key);
      globalScope.localStorage.setItem(localKey, JSON.stringify(val));
      this.cache.set(localKey, val);
    } catch (err) {
      console.error(err);
    }
  }

  public remove(key) {
    try {
      const localKey = this.keyFor(key);
      globalScope.localStorage.removeItem(localKey);
      this.cache.delete(localKey);
    } catch (err) {
      console.error(err);
    }
  }

  public clearCachedNamespace() {
    globalScope.persistenceMemoryCache[this.namespace] = null;
  }

  public clear(key) {
    globalScope.localStorage.removeItem(this.keyFor(key));
  }

  private keyFor(key) {
    return `${this.namespace}:${key}`;
  }
}
